import { render } from "./ThumbsRating.vue?vue&type=template&id=4eae7206&scoped=true"
import script from "./ThumbsRating.vue?vue&type=script&lang=js"
export * from "./ThumbsRating.vue?vue&type=script&lang=js"

import "./ThumbsRating.vue?vue&type=style&index=0&id=4eae7206&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eae7206"]])

export default __exports__